import { useEffect } from "react";

export interface SeoConfig {
  title: string;
  description: string;
  keywords: string;
  path: string;
  ogType?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

const SITE_NAME = "黑料专区";
const ORIGIN = "https://leiysp.cn";

function upsertMeta(attr: "name" | "property", key: string, value: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function upsertLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSeo(config: SeoConfig) {
  const { title, description, keywords, path, ogType, jsonLd } = config;
  const jsonLdString = jsonLd ? JSON.stringify(jsonLd) : "";

  useEffect(() => {
    const url = `${ORIGIN}${path}`;
    document.title = title;

    upsertMeta("name", "description", description);
    upsertMeta("name", "keywords", keywords);
    upsertMeta("name", "robots", "index,follow");

    upsertLink("canonical", url);

    upsertMeta("property", "og:site_name", SITE_NAME);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", ogType || "website");
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:locale", "zh_CN");

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);

    const existing = document.getElementById("page-jsonld");
    if (existing) existing.remove();

    if (jsonLdString) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "page-jsonld";
      script.textContent = jsonLdString;
      document.head.appendChild(script);
    }

    return () => {
      const current = document.getElementById("page-jsonld");
      if (current) current.remove();
    };
  }, [title, description, keywords, path, ogType, jsonLdString]);
}

export { SITE_NAME, ORIGIN };